import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HttpUtilsService {
  private errPlaceholderMsgKey = 'errors.placeholder';

  private map: Map<string, string> = new Map([
    ['error-code-test', 'errors.test'],
  ]);

  //Resolve the error code translation key
  getCorrespondingTranslationKey(code?: string): string {
    if (code) {
      return this.map.get(code)
        ? this.map.get(code)
        : this.errPlaceholderMsgKey;
    } else {
      return this.errPlaceholderMsgKey;
    }
  }
}
